import Tabs from '@mui/material/Tabs'
import flattenChildren from "react-keyed-flatten-children"

export type TabContainerProps = React.ComponentProps<typeof Tabs> & {
  tabSections: (React.ReactNode | boolean | undefined | null)[]
}

export default function TabContainer({ tabSections, ...props }) {
  return (
    <Tabs {...props}>
      {flattenChildren(tabSections)}
    </Tabs>
  )
}
